module.exports = __webpack_public_path__ + "img/call_white_24dp.f3681abb.svg";